<div>
    <mat-form-field class="example-form-field">
        <mat-label>Fecha</mat-label>
        <input matInput [matDatepicker]="picker" 
               [formControl]="selectedDate" 
               (dateChange)="onDateChange($event)">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
</div>

<mat-card class="cardWithShadow">
    <mat-card-content>
        <div class="container_button_company">
            <mat-card-title>Factoring - Oportunidades Ultimas {{this.hours}}Hrs</mat-card-title>
            <br>
        </div>

        <div class="kpi-container" *ngIf="dataSource.data.length > 0">
            <mat-card class="kpi-card">
                <mat-card-content>
                    <div class="kpi-value">{{ getTotalInvoices() }}</div>
                    <div class="kpi-label">Total Facturas</div>
                </mat-card-content>
            </mat-card>

            <mat-card class="kpi-card">
                <mat-card-content>
                    <div class="kpi-value">{{ getTotalAmount() | currency:"CLP":"symbol" }}</div>
                    <div class="kpi-label">Monto Total</div>
                </mat-card-content>
            </mat-card>

            <mat-card class="kpi-card">
                <mat-card-content>
                    <div class="kpi-value">{{ getUniqueClients() }}</div>
                    <div class="kpi-label">Clientes</div>
                </mat-card-content>
            </mat-card>

            <mat-card class="kpi-card">
                <mat-card-content>
                    <div class="kpi-value">{{ getUniqueDebtors() }}</div>
                    <div class="kpi-label">Deudores</div>
                </mat-card-content>
            </mat-card>
        </div>

        <div *ngIf="this.loading==true">
            <mat-spinner style="width: 50px;"></mat-spinner>
        </div>
        <div style="text-align: center;"  *ngIf="this.loading == false && dataSource.data.length == 0">
            <h3>Sin oportunidades para el rango de fechas seleccionado</h3>
        </div>

        <div class="overflow-table" *ngIf="dataSource.data.length > 0">
            <table mat-table matSort (matSortChange)="changeSorting($event)" [dataSource]="dataSource">
                <ng-container matColumnDef="HeaderCliente">
                    <th mat-header-cell *matHeaderCellDef colspan="2" class="client fill bl bt"> Cliente </th>
                </ng-container>
                
                <ng-container matColumnDef="HeaderDeudor">
                    <th mat-header-cell *matHeaderCellDef colspan="2" class="debtor fill bl bt"> Deudor </th>
                </ng-container>
                <!-- <ng-container matColumnDef="HeaderMP">
                    <th mat-header-cell *matHeaderCellDef colspan="2" class="mp fill bl bt"> Mercado público (Deudor)</th>
                </ng-container> -->
                <ng-container matColumnDef="HeaderFactura">
                    <th mat-header-cell *matHeaderCellDef colspan="3" class="invoice fill bl bt"> Factura </th>
                </ng-container>
                <ng-container matColumnDef="HeaderEjecutivo">
                    <th mat-header-cell *matHeaderCellDef colspan="2" class="invoice fill bl bt br"> Ejecutivo </th>
                </ng-container>

                <ng-container matColumnDef="RutCliente">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="client fill bl">
                        <div>
                            Rut
                            <mat-form-field class="filter-field">
                                <input matInput (keyup)="applyFilter($event, 'rutCompletoProveedor')" placeholder="Filtrar">
                            </mat-form-field>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="client fill bl">
                        <h6>{{ element.rutCompletoProveedor }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="NombreCliente" class="client fill">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="client">
                        <div>
                            Nombre
                            <mat-form-field class="filter-field">
                                <input matInput (keyup)="applyFilter($event, 'nombreProveedor')" placeholder="Filtrar">
                            </mat-form-field>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="client">
                        <h6>{{ element.nombreProveedor }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="RutDeudor">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="debtor fill bl">
                        <div>
                            Rut
                            <mat-form-field class="filter-field">
                                <input matInput (keyup)="applyFilter($event, 'rutCompletoCliente')" placeholder="Filtrar">
                            </mat-form-field>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="debtor fill bl">
                        <h6 class="single-line">{{ element.rutCompletoCliente}}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="NombreDeudor">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="debtor">
                        <div>
                            Nombre
                            <mat-form-field class="filter-field">
                                <input matInput (keyup)="applyFilter($event, 'nombreCliente')" placeholder="Filtrar">
                            </mat-form-field>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="debtor">
                        <h6 class="single-line">{{ element.nombreCliente }}</h6>
                    </td>
                </ng-container>
                <!-- <ng-container matColumnDef="ReclamosDeudor">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef class="mp fill bl"> 
                        Reclamos
                    </th>
                    <td mat-cell *matCellDef="let element" class="mp fill bl">
                        <h6 class="single-line">{{ element.nReclamosDeudor }}</h6>
                    </td>
                </ng-container>
                <ng-container matColumnDef="OrdenesDeCompraMP">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef class="mp">
                        OC
                    </th>
                    <td mat-cell *matCellDef="let element" class="mp" >
                        <h6 class="single-line">{{ element.ordenesCompraMp }}</h6>
                    </td>
                </ng-container> -->
                
                <ng-container matColumnDef="MontoFactura">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="invoice">
                        <div>
                            Monto total
                            <mat-form-field class="filter-field">
                                <input matInput (keyup)="applyFilter($event, 'monto')" placeholder="Filtrar">
                            </mat-form-field>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="invoice">
                        <h6 class="single-line">{{ element.monto | currency:"CLP":"symbol" }}</h6>
                    </td>
                </ng-container>
                <ng-container matColumnDef="Folio">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="invoice fill bl">
                        <div>
                            Folio
                            <mat-form-field class="filter-field">
                                <input matInput (keyup)="applyFilter($event, 'folio')" placeholder="Filtrar">
                            </mat-form-field>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="invoice fill bl">
                        <h6 class="single-line">{{ element.folio }}</h6>
                    </td>
                </ng-container>
                <ng-container matColumnDef="FechaEmision">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="invoice fill br">
                        <div>
                            Fecha
                            <mat-form-field class="filter-field">
                                <input matInput (keyup)="applyFilter($event, 'fechaEmision')" placeholder="Filtrar">
                            </mat-form-field>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="invoice fill br">
                        <h6 class="single-line">{{ element.fechaEmision | date : 'dd-MM-yyyy' }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="EjecutivoGarantias">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="invoice fill">
                        <div>
                            Garantías
                            <mat-form-field class="filter-field">
                                <input matInput (keyup)="applyFilter($event, 'ejecutivoGarantias')" placeholder="Filtrar">
                            </mat-form-field>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="invoice fill">
                        <h6 class="single-line">{{ element.ejecutivoGarantias }}</h6>
                    </td>
                </ng-container>
                <ng-container matColumnDef="EjecutivoFactoring">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="invoice fill br">
                        <div>
                            Factoring
                            <mat-form-field class="filter-field">
                                <input matInput 
                                       [disabled]="isExecutiveFilterDisabled()"
                                       (keyup)="applyFilter($event, 'ejecutivoFactoring')" 
                                       placeholder="Filtrar">
                            </mat-form-field>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="invoice fill br">
                        <h6 class="single-line">{{ element.ejecutivoFactoring }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="disclaimer">
                    <td mat-footer-cell *matFooterCellDef colspan="11" class="invoice fill bt">
                    </td>
                  </ng-container>
                <tr mat-header-row *matHeaderRowDef="['HeaderCliente', 'HeaderDeudor','HeaderFactura','HeaderEjecutivo']"
                    class="example-second-header-row">
                </tr>
                <tr mat-header-row *matHeaderRowDef="displayCols" class="example-second-header-row"></tr>
                
                <tr mat-row *matRowDef="let row; columns: displayCols" (dblclick)="openUrl(row.rutProveedor)" [ngClass]="{'priorized': row.destacada == true || row.deudorDestacado==true}"></tr>
                <tr mat-footer-row *matFooterRowDef="['disclaimer']" class="example-second-footer-row"></tr>
            </table>
        </div>
        <div>
            <mat-paginator [pageSize]="10"
                          [pageSizeOptions]="[10, 20, 50, 100]"
                          showFirstLastButtons
                          aria-label="Seleccionar página">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>